  import axios  from "axios";
  export const HandleSurveyors = async(data,setter) => {
        const {surveyor_name,surveyor_email,surveyor_phone,surveyor_password,surveyor_image} = data;
        const {setSurveyor_error,setSurveyors,Surveyors} = setter;
          try {
            const formData = new FormData();
            formData.append('name',surveyor_name);
            formData.append('email',surveyor_email);
            formData.append('phone',surveyor_phone);
            formData.append('password',surveyor_password);
            formData.append('image',surveyor_image);
            const response = await axios.post('https://land-survey-project-2.onrender.com/Addsurveyor',formData);
            if(response && response.data && response.data.errors){
              const error = response.data.errors;
              setSurveyor_error(error.name ?. msg || error.email ?. msg || error.password ?. msg || error.phone ?. msg);
            }
            if(response && response.data && response.data.message && response.data.surveyor){
              if(response.data.status){
                  setSurveyors(response.data.surveyor);
                  if(Surveyors) Surveyors();
                  console.log(response.data.surveyor);
                  setSurveyor_error('');
                  alert(response.data.message);
              }else{
                 setSurveyor_error(response.data.message); 
              }
            }
            if(response && response.data){
              if(response.data.error){
                setSurveyor_error(response.data.message);
              }
            }
          } catch (err) {
          console.log(err);
          }
        }